import { FormHelperText } from "@material-ui/core";
import {
  IVoucherLimitActions,
  IVoucherLimitState,
  TOperation
} from "@saleor/discounts/hooks/useVoucherLimitsData";
import React, { Dispatch, FC, useCallback } from "react";
import { useIntl } from "react-intl";

import { useCommonFieldStyles } from "../../styles";
import CustomerActivitySubfield from "../CustomerActivitySubfield/CustomerActivitySubfield";
import RadioButton from "../RadioButton/RadioButton";

interface ILimitCustomerActivityRButtonProps {
  radioButtonValue: boolean;
  onRadioButtonValueChange: (val: boolean) => void;
  isDisabled: boolean;
  voucherLimitState: IVoucherLimitState;
  voucherLimitDispatcher: Dispatch<IVoucherLimitActions>;
  clientErrors?: {
    hasVoucherConditions?: string;
  };
}

const LimitCustomerActivityRButton: FC<ILimitCustomerActivityRButtonProps> = ({
  radioButtonValue,
  onRadioButtonValueChange,
  isDisabled,
  voucherLimitState,
  voucherLimitDispatcher,
  clientErrors
}) => {
  const intl = useIntl();
  const classes = useCommonFieldStyles(undefined);

  const handleCheckboxChange = (
    voucherConditionType: "ongoing-order" | "swipe-coupons"
  ) => () => {
    voucherLimitDispatcher({ type: "toggle-checkbox", voucherConditionType });
  };

  const handleConditionChange = (
    voucherConditionType: "ongoing-order" | "swipe-coupons"
  ) => (value: TOperation) => {
    voucherLimitDispatcher({
      type: "update-condition",
      value,
      voucherConditionType
    });
  };

  const handleNumberValueChange = useCallback(
    (voucherConditionType: "ongoing-order" | "swipe-coupons") => (
      value: number
    ) => {
      voucherLimitDispatcher({
        type: "update-value",
        value,
        voucherConditionType
      });
    },
    [voucherLimitDispatcher]
  );

  return (
    <div className={classes.divContainerStyle}>
      <RadioButton
        label={intl.formatMessage({
          defaultMessage: "Limit to customer activity"
        })}
        value={radioButtonValue}
        onChange={onRadioButtonValueChange}
        isDisabled={isDisabled}
      />
      {!!clientErrors.hasVoucherConditions && (
        <FormHelperText className={classes.errorHelperTextStyle}>
          {clientErrors.hasVoucherConditions}
        </FormHelperText>
      )}
      {radioButtonValue && (
        <CustomerActivitySubfield
          checkBoxLabel={intl.formatMessage({
            defaultMessage: "With Ongoing Order(s)"
          })}
          textFieldLabel={intl.formatMessage({
            defaultMessage: "No. of Orders"
          })}
          isDisabled={isDisabled}
          checkboxValue={voucherLimitState.isWithOngoingOrders}
          onToggleCheckbox={handleCheckboxChange("ongoing-order")}
          condition={voucherLimitState.ongoingOrderVoucherCondition.operation}
          setCondition={handleConditionChange("ongoing-order")}
          numberValue={voucherLimitState.ongoingOrderVoucherCondition.value}
          setNumberValue={handleNumberValueChange("ongoing-order")}
        />
      )}
      {radioButtonValue && (
        <CustomerActivitySubfield
          checkBoxLabel={intl.formatMessage({
            defaultMessage: "With Swipe Coupon(s)"
          })}
          textFieldLabel={intl.formatMessage({
            defaultMessage: "No. of Redeemed Coupons"
          })}
          isDisabled={isDisabled}
          checkboxValue={voucherLimitState.isWithSwipeCoupons}
          onToggleCheckbox={handleCheckboxChange("swipe-coupons")}
          condition={voucherLimitState.swipeCouponVoucherCondition.operation}
          setCondition={handleConditionChange("swipe-coupons")}
          numberValue={voucherLimitState.swipeCouponVoucherCondition.value}
          setNumberValue={handleNumberValueChange("swipe-coupons")}
        />
      )}
    </div>
  );
};

export default LimitCustomerActivityRButton;
